import type { RouteObject } from "react-router-dom";
import { Navigate } from "react-router-dom";
import RoleProtectedRoute from "../../router/RoleProtectedRoute";
import PayrollLayout from "./PayrollLayout";
import { MENU, PAYROLL_BASE, payrollDefaultRoute } from "./config";
import { PayrollTabGuard } from "./access";

// Construye el árbol de rutas /payslip desde la config de navegación, para que
// el sub-menú y las rutas no se desincronicen. Mismo patrón que
// Layouts/mantenimiento/routes.tsx y Layouts/release/routes.tsx.
const children: RouteObject[] = [
  { index: true, element: <Navigate to={payrollDefaultRoute} replace /> },
  // #1142: las pestañas que no son para colaboradores redirigen a «Mis pagos».
  ...MENU.map((item) => ({
    path: item.id,
    element: <PayrollTabGuard tabId={item.id}>{item.element}</PayrollTabGuard>,
  })),
  // #1141: «Periodos» se fundió con «Historial pagado»; los enlaces viejos siguen sirviendo.
  { path: "periods", element: <Navigate to={`${PAYROLL_BASE}/paid-history`} replace /> },
];

export const payrollRoute: RouteObject = {
  path: PAYROLL_BASE,
  element: <RoleProtectedRoute restrictedRoles={["web_services"]} />,
  children: [
    {
      path: "",
      element: <PayrollLayout />,
      children,
    },
  ],
};
